import React, { Suspense } from 'react';
import { Spinner } from 'react-bootstrap';

// Lazy load ReactQuill
const ReactQuill = React.lazy(() => import('react-quill'));

// Simple wrapper without ref forwarding to avoid findDOMNode issues
const QuillEditor = (props) => {
    return (
        <Suspense fallback={<Spinner animation="border" size="sm" />}>
            <ReactQuill {...props} />
        </Suspense>
    );
};

QuillEditor.displayName = 'QuillEditor';

export default QuillEditor;